import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Component, Input, OnInit, inject, output, OutputEmitterRef, DestroyRef } from '@angular/core';
import { ReportTimerService } from '@app/services/report-timer/report-timer.service';
import { filter } from 'rxjs/operators';
import { Timer } from '@app/modules/views/reports/timer.model';

@Component({
	selector: 'lawyal-front-end-collapsed-timer',
	templateUrl: './collapsed-timer.component.html',
	styleUrls: ['./collapsed-timer.component.scss'],
	standalone: false
})
export class CollapsedTimerComponent implements OnInit {
	private readonly destroyRef: DestroyRef = inject(DestroyRef);

	private timerService = inject(ReportTimerService);

	@Input() set timerData(value: Timer) {
		this.duration_ms = undefined;

		if (value) {
			this.timer = value;

			if (this.timer.active) {
				this.timerService.startInterval(this.timer.duration_ms, false);
			}
		}
	}

	readonly startTimer: OutputEmitterRef<Timer> = output<Timer>();
	readonly stopTimer: OutputEmitterRef<number> = output<number>();
	readonly expand: OutputEmitterRef<Timer> = output<Timer>();

	timer: Timer;
	duration_ms: number;

	ngOnInit() {
		this.timerService.durationTimer$
			.pipe(
				filter(data => !!data && !data.fromModal),
				takeUntilDestroyed(this.destroyRef)
			)
			.subscribe(data => {
				this.duration_ms = data.duration;
			});
	}

	startCounter() {
		const startTimerData: Timer = {
			id: this.timer.id
		};

		this.startTimer.emit(startTimerData);
	}

	stopCounter() {
		this.stopTimer.emit(this.timer.id);
	}

	expandModal() {
		this.expand.emit(this.timer);
	}
}
